// import { getStorage } from "firebase/storage";
import {addDoc, collection, getDocs, getDoc, query, updateDoc, doc, where} from "firebase/firestore";
import {db} from "@/main";
import axios from "axios";
import apiRoute from "../../router/api-routes";

const xApiKey = 'HP9X6hH9n00mMVToKZxGWr12Olwczav4Pj5';
const allFunctions = {
    async createAffectations(data) {
        const response = await axios.post(apiRoute.baseURL + apiRoute.createAffectations, data, {
            headers: {
            'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    async createKillometrage(data) {
        const response = await axios.post(apiRoute.baseURL + apiRoute.createKillometrage, data, {
            headers: {
            'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    async getKillometrage(data) {
        const queryParams = {};
        
        // Construire l'objet des paramètres
        if (data.campagneId) queryParams.campagneId = data.campagneId;
        if (data.affectationId) queryParams.affectationId = data.dateDebut;
        if (data.dateFin) queryParams.dateFin = data.dateFin;
        if (data.dateDebut) queryParams.dateDebut = data.dateDebut;
        
        const response = await axios.get(apiRoute.baseURL + apiRoute.createKillometrage, {
            params: queryParams,
            headers: {
                'x-api-key': xApiKey,
            }
        });
        
        return response.data;
    },


    async findOneCampagn(data) {
        const response = await axios.post(apiRoute.baseURL + apiRoute.findOneCampagn, data, {
            headers: {
            'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    async getRecensements(data) {
        const queryParams = {};
        
        // Construire l'objet des paramètres
        if (data.campagneId) queryParams.campagneFirebaseId = data.campagneId;
        if (data.dateDebut) queryParams.dateDebut = data.dateDebut;
        if (data.dateFin) queryParams.dateFin = data.dateFin;
        if (data.codeAgent) queryParams.codeAgent = data.codeAgent;
        if (data.type) queryParams.type = data.type;
        
        const response = await axios.get(apiRoute.baseURL + apiRoute.getRecensements, {
            params: queryParams,
            headers: {
                'x-api-key': xApiKey,
            }
        });
        
        return response.data;
    },

    async getVentes(data) {
        const response = await axios.get(apiRoute.baseURL + apiRoute.getVentes + '?campagneFirebaseId=' + data.campagneId, {
            headers: {
            'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    // async getVentes(config = {}) {
    //     try {
    //         // Construction de l'URL avec les paramètres
    //         let url = apiRoute.baseURL + apiRoute.getVentes;
            
    //         // Si des paramètres sont fournis, les ajouter à l'URL
    //         if (config.params) {
    //             const searchParams = new URLSearchParams(config.params);
    //             url += '?' + searchParams.toString();
    //         }
            
    //         const response = await axios.get(url, {
    //             headers: {
    //                 'x-api-key': xApiKey,
    //                 'Content-Type': 'application/json'
    //             }
    //         });
            
    //         return response.data;
    //     } catch (error) {
    //         console.error('Erreur getVentes:', error);
    //         throw error;
    //     }
    // },

    async getAffectations(data) { 
        const response = await axios.get(apiRoute.baseURL + apiRoute.getAffectations + '?firebaseId=' + data.campagneId, {
            headers: {
            'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    async getCommercial() { 
        const response = await axios.get(apiRoute.baseURL + apiRoute.getCommercial, {
            headers: {
            'x-api-key': xApiKey,
            }
        })
        return response.data.reverse();
    },

    async createCommercial(data) {
        const response = await axios.post(apiRoute.baseURL + apiRoute.createCommercial, data, {
            headers: {
            'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    async createPrestataire(data) {
        const response = await axios.post(apiRoute.baseURL + apiRoute.createPrestataire, data, {
            headers: {
            'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    async createClient(data) {
        const response = await axios.post(apiRoute.baseURL + apiRoute.createClient, data, {
            headers: {
            'x-api-key': xApiKey,
            }
        })
        return response.data
    },
    

    // async getClient(data) { 
    //     const response = await axios.get(apiRoute.baseURL + apiRoute.getClient, data, {
    //         headers: {
    //         'x-api-key': xApiKey,
    //         }
    //     })
    //     return response.data
    // },

    async getClient() { 
        const response = await axios.get(apiRoute.baseURL + apiRoute.getClient, {
            headers: {
                'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    async getOneClient(id) {
        const response = await axios.get(apiRoute.baseURL + apiRoute.getOneClient + '/' + id, {
            headers: {
                'x-api-key': xApiKey,
            }
        })

        return response.data
    },

    async patchUpdateClient(id, data) {
        const response = await axios.patch(apiRoute.baseURL + apiRoute.patchUpdateClient + '/' + id, data, {
            headers: {
                'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    async createCampagn(data) {
        const response = await axios.post(apiRoute.baseURL + apiRoute.createCampagn, data, {
            headers: {
            'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    async getAllCampagn(page, limit) {
        const response = await axios.get(apiRoute.baseURL + apiRoute.getAllCampagn + '?page=' + page + '&limit=' + limit, {
            headers: {
                'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    async getCampagn(data) { 
        const response = await axios.get(apiRoute.baseURL + apiRoute.getCampagn, data, {
            headers: {
            'x-api-key': xApiKey,
            }
        })
        return response.data
    },

    /* Upload file */
    async uploadFile(file) {
        console.log('iciUpload')
        try {
            const formData = new FormData();
            formData.append('file', file); 
            formData.append('type', 'OTHER'); 
            formData.append('application', 'PANNEAU_MOBILE'); 
            formData.append('person', 'ADMIN'); 
            const response = await axios.post(
            'https://api-file-manager.iryka.com/api/v1/files/create-file',
            formData,
            {
                headers: {
                'x-api-key': 'a158TOKX-99ae-47d6-b7f1-58b9bd6ff639',
                'Content-Type': 'multipart/form-data',
                }
            }
            )

            console.log("✅ Réponse upload:", response.data.realUrl)
            return response.data.realUrl; // ← retourne la data ici
        } catch (error) {
            console.error('❌ Erreur lors du téléchargement du fichier:', error.response?.data || error.message);
            throw error;
        }
    },

    async simpleGetRequest(route) {
        const allData = query(collection(db, route))
        // this.allAccount = allData
        const response = []
        const querySnapshot = await getDocs(allData);
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, " => ", doc.data());
            const data = doc.data()
            data.id = doc.id
            response.push(data)
        });
        return response
    },

    async findOne(route, id) {
        const docum = doc(db, route, id);
        const docSnap = await getDoc(docum);

        if (docSnap.exists()) {
            // console.log("Document data:", docSnap.data());
            return docSnap.data()
        } else {
            // docSnap.data() will be undefined in this case
            console.log("No such document!");
            return null
        }
    },

    async findByClient(route, clientId) {
        const citiesRef = collection(db, route);

        const q = query(citiesRef, where("clientId", "==", clientId));

        const response = []
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, " => ", doc.data());
            const data = doc.data()
            data.id = doc.id
            response.push(data)
        });

        return response
    },

    orderListBy(prop) {
        return function (a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            }
            if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        };
    },

    async updateDoc(route, id, data) {
        await updateDoc(doc(db, route, id), data).then((e) => {
            console.log('success', e)
            return 'success'
        }).catch((e) => {
            console.log('error', e)
        });
    },

    async saveDoc(route, data) {
        await addDoc(collection(db, route), data)
            .then((e) => {
                console.log('success', e)
            return 'success'
        }).catch((e) => {
                console.log('error', e)
                return null
            })
    },

    dateDifference (now, endDate) {
        const x = new Date(endDate);
        const y = new Date(now);

        // secondes = millisecondes/1000
        // minutes = secondes/60
        // heures = minutes/60
        // Jours = heures/24

        const diffInDays = Math.floor((x - y) / (1000 * 60 * 60 * 24));
        // console.log(diffInDays);
        return diffInDays
    },
};
export default allFunctions;
